import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { translationHelper } from '~/helpers/translation.helper';

import { LoginService } from '../login/services/login.service';
import { CoreService, CustomerUser } from '../services/core.service';
import { TournamentsService } from '../tournaments/services/tournaments.service';
declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'comp_infomodal',
    templateUrl: './info_modal.html',
})
export class InfoModal implements OnInit {
    public init: boolean;

    selectedMenuID = 'overview';

    constructor(public tournamentsService: TournamentsService, public _translationHelper: translationHelper) {}
    public ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;
    }
    public InfoModal_Close() {
        $('#Info_Modal').modal('hide');
    }

    setMenu(v) {
        this.selectedMenuID = v;
    }

    // todo needs to translate .. check html

    // SignOut() {
    //    $('#Info_Modal').modal('hide');
    //    this.loginService.singOut(this.coreService.customerUser);
    //    this.coreService.customerUser.IsLogged = false;
    //    this.loginService.LoginState = 0;
    //    window.location.reload();
    // }
}
